module.exports = __webpack_public_path__ + "static/l3_large-5d744e29958369d953f465bd3a7d7789.jpg";